import { render, staticRenderFns } from "./personalContent.vue?vue&type=template&id=4dff0d36&scoped=true"
import script from "./personalContent.vue?vue&type=script&lang=js"
export * from "./personalContent.vue?vue&type=script&lang=js"
import style0 from "./personalContent.vue?vue&type=style&index=0&id=4dff0d36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff0d36",
  null
  
)

export default component.exports